// extracted by mini-css-extract-plugin
export default {"featuredDishes":"product-view_featuredDishes__2W-gG","viewAll":"product-view_viewAll__l8NPA"};